import { put, select } from "redux-saga/effects";
import { getZapierAuthURLFailure, getZapierAuthURLSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* handleGetZapierAuthURL() {
    try {
        const formId: string = yield select(state => state.forms.current._id);

        const data: { data: { url: string } } = yield IntegrationService.getZapierAuthURL(formId);
        yield put(
            getZapierAuthURLSuccess({
                authUrl: data.data.url,
                formId,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.data?.message || "Failed to get Zapier authentication URL";
        yield put(getZapierAuthURLFailure(errorMessage));
    }
}
